import { render, staticRenderFns } from "./TmEditor.vue?vue&type=template&id=4fd21290&scoped=true&"
import script from "./TmEditor.vue?vue&type=script&lang=js&"
export * from "./TmEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd21290",
  null
  
)

export default component.exports